import { Heading } from '@tiptap/extension-heading'

export function sanitizeJavaScriptCode(jsCode: string | null | undefined = '') {
  // Remove HTML tags and leading/trailing white spaces
  return jsCode?.replace(/<\/?[^>]+(>|$)/g, '').trim()
}

// This extension will disable markdown syntax like #(which applies css), because it conflicts with mentions
// Use Case: while tagging with #, editor starts treating this has and complete mention as h1 tag,this function will disable this behavior
export const HeadingConfiguration = Heading.configure({
  HTMLAttributes: {},
  levels: [1, 2, 3, 4, 5, 6],
}).extend({
  addInputRules() {
    return [] // Disable markdown syntax like #, because it conflicts with mentions
  },
})
